import { render, staticRenderFns } from "./singlePausedSubscription.vue?vue&type=template&id=edd3cb80&"
import script from "./singlePausedSubscription.vue?vue&type=script&lang=js&"
export * from "./singlePausedSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports